import http from '@/api/http';

export async function login(login, password, code) {
    try {
        let param = ''

        if (code) {
            param = '?code=' + code
        }

        // btoa принимает только Latin1 — кодируем через TextEncoder, иначе Unicode-пароли падают
        const credentials = String.fromCharCode(...new TextEncoder().encode(login + ":" + password))
        const response = await http.get('api/v1/auth' + param, { headers: { 'Authorization': 'Basic ' + btoa(credentials), 'Content-Type': 'application/json', } })
        
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return error.response.data
    }
}

export async function register(data) {
    try {
        let dataPram = {
            'username': data.username,
            'first_name': data.first_name,
            'last_name': data.last_name,
            'mail': data.mail,
            'password': data.password 
        }
        if (data.code) {
            dataPram["code"] = data.code
        }
        if (data.mailing) {
            dataPram["mailing"] = data.mailing
        }

        const response = await http.post('api/v1/register',
            dataPram,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
        // commit('SET_USER_DATA', response.data)
        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return error.response.data
    }
}

export async function activate(key) {
    try {
        const response = await http.get('api/v1/register/new?key=' + key, {
            headers: { 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return error.response.data
    }
}

export async function resendCode(email) {
    try {
        const dataPram = {
            mail: email
        }
        const response = await http.post('api/v1/register/two-active', 
            dataPram,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return error.response.data
    }
}

export async function restore(email) {
    try {
        let dataPram = {
            'mail': email
        }

        const response = await http.post('api/v1/register/recovery-pass', 
            dataPram, 
            { 
                headers: { 'Content-Type': 'multipart/form-data' } 
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function fetchData(token) {
    try {
        const response = await http.get('api/v1/user', {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function recentProjects(token) {
    try {
        const response = await http.get('api/v1/user/open-project', {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function userInfo(token) {
    try {
        const response = await http.get('api/v1/user', {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function changePassword(token, data) {
    try {
        let dataPram = {
            'pass_old': data.old,
            'pass_new': data.new,
            'pass_new_two': data.new2
        }

        // console.log(dataPram);
        const response = await http.post('api/v2/setting/user-pass',
            dataPram,
            { headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data'} })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return error.response.data
    }
}

export async function saveSettings(token, data) {
    try {
        let dataPram = {
            'first_name': data.first_name,
            'last_name': data.last_name,
            'lang': data.lang,
            'mailing': data.mailing
        }

        // console.log(dataPram);
        const response = await http.post('api/v2/setting/user',
            dataPram,
            { headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data'} })

        return response.data ? true : false

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return false
    }
}

export async function uploadAvatar(token, data) {
    try {
        const response = await http.post('api/v1/user/image', data,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data'
                }
            })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}

export async function removeAvatar(token, id) {
    try {
        const response = await http.delete('api/v1/user/image?id=' + id, {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function myTasks(token, params = {}) {
    try {
        const query = new URLSearchParams()

        if (params.role) query.set('role', params.role)
        if (params.period) query.set('period', params.period)
        if (params.search) query.set('search', params.search)
        if (params.project_id) query.set('project_id', params.project_id)
        if (params.company_id) query.set('company_id', params.company_id)
        if (params.sort) query.set('sort', params.sort)
        if (params.limit) query.set('limit', params.limit)
        if (params.offset) query.set('offset', params.offset)

        const qs = query.toString()
        const response = await http.get('api/v1/user/my-tasks',
            {
                params: params,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            }
        )

        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function getConfig(token) {
    try {
        const response = await http.get('api/v1/user/config', {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function saveConfig(token, key, config) {
    try {
        const formData = new FormData()
        formData.append('key', key)
        formData.append('config', JSON.stringify(config))

        const response = await http.post('api/v1/user/config', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function listSpacesPermissions(token) {
    try {
        const response = await http.get(
            'api/v1/user/list-role-tarif-all',
            {
                headers: { 'Authorization': 'Bearer ' + token }
            })
        return response.data
    } catch (error) {
        return []
    }
}